import React from 'react';
import PropTypes from 'prop-types';

import {withIsOpenState} from '../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import {OEGroupControl, OETextFieldControl} from '../../elements/controls/oe-controls';
import {OEModalStyle} from '../../modals/oe-modal';
import {OEPresetType} from '../preset/oe-preset-model';
import {OEPresetController} from '../preset/oe-preset-controller';
import OEPopover from '../../views/oe-popover';
import retardUpdate from '../../../lib/react/update-retarder';

export class OEPresentationPresetController extends React.PureComponent {

    constructor(props)  {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            uiEnabled:      false,
            data:           null,
            userRef:        '',
            strings: {
                userRef:    ''
            }
        };

        this.updateLanguage = this.updateLanguage.bind(this);
        this.onPresentationDataChanged = this.onPresentationDataChanged.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onPresetApplyBtnPressed = this.onPresetApplyBtnPressed.bind(this);
        this.onUserRefInputChanged = this.onUserRefInputChanged.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.id != this.props.id)   {
            this.updatePresentationData(undefined, nextProps);
            this.updateUIState(nextProps);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationDataChanged, this.onPresentationDataChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationDataChanged, this.onPresentationDataChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;

        this.setState({
            strings: {
                userRef: si.getLocalizedStringEnc('presentation_apply_presets_view_user_reference'),
            }
        });
    }

    updatePresentationData(data, props)   {
        data = data || null;
        props = props || this.props;
        if(this.oe.isReady() && !data && props.id >= 0)  {
            let pres = this.oe.sharedInterface.getUIControllerPresentation();
            data = pres.getPresentationDataID(props.id)
        }
        this.setState({data: data});

        if(data && typeof(data.playableFlags) === 'number') {
            this.setState({playableFlags: data.playableFlags});
        }
    }

    updateUIState(props)   {
        props = props || this.props;
        let uiEnabled = this.oe.sharedInterface.getUIControllerPresentation().getUIEnabled();

        this.setState({
            uiEnabled: uiEnabled
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.setState({
                uiEnabled: false,
                data: null
            });
            return;
        }

        retardUpdate(this, () => {
            this.updateLanguage();
            this.updatePresentationData();
            this.updateUIState();
        });
    }

    onPresentationDataChanged(message, userInfo)    {
        if(this.props.id < 0 || this.props.id != userInfo.presID) return;
        this.updatePresentationData(userInfo.presData);
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.presentation) {
            this.updateUIState();
        }
    }

    render()    {
        return(
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <div className={'presentation-preset-controller ' + this.props.className}>

                    <OEPresetController
                        moduleId={this.props.moduleId}
                        appComponent={this.props.appComponent}
                        icon={this.props.icon}
                        title={this.props.title}
                        titleId={this.props.titleId}
                        headerSeparator={this.props.headerSeparator}
                        presetType={this.props.presetType}
                        showTypeIconAllways={this.props.showTypeIconAllways}
                        applyPresetEnabled={this.state.uiEnabled && this.props.id >= 0 && this.state.data && this.state.data.slides.length > 0 && !!this.state.userRef}
                        onPresetApplyBtnPressed={this.onPresetApplyBtnPressed}
                        onToggle={this.props.onToggle}
                    />
                    
                    <OEGroupControl title={this.state.strings.userRef} topSeparator={true}>
                        <OETextFieldControl 
                            className="std-label-border-color search-input"
                            clearButton={false}
                            value={this.state.userRef}
                            onChange={this.onUserRefInputChanged}
                        />
                    </OEGroupControl>
                </div>
            </React.Fragment>
        );
    }

    onPresetApplyBtnPressed(sender, presetId)  {
        if(!this.oe.isReady() || this.props.id < 0 || !this.state.userRef) return;

        let si = this.oe.sharedInterface;
        let pres = si.getUIControllerPresentation();

        this.props.appComponent.showWaitingController();

        pres.applyPresetToPresentationID(this.props.id, presetId, this.state.userRef, (result) => {
            this.props.appComponent.hideWaitingController();

            let buttons = (id, container) => [{title: si.getLocalizedStringEnc('alert_ok'), onClick: () => { container.closeModal(id) }, className: 'btn-primary'}];

            if(result.result === this.oe.Module.PresentationApplyPresetResultCode.ok)  {

                this.props.appComponent.module.addModal(
                    si.getLocalizedStringEnc('alert_succeeded_title'),
                    si.getLocalizedStringEnc('alert_pres_preset_msg_succeeded').replaceAll('#notes', result.count.toString()).replaceAll('#slides', result.slideCount.toString()),
                    buttons,
                    {style: OEModalStyle.message}
                );

            } else {

                this.props.appComponent.module.addModal(
                    si.getLocalizedStringEnc('alert_error_title'),
                    si.getLocalizedStringEnc('alert_pres_preset_msg_error').replaceAll('#notes', result.count.toString()).replaceAll('#slides', result.slideCount.toString()),
                    buttons
                );
            }
        });
    }

    onUserRefInputChanged(sender, value)  {
        this.setState({userRef: value});
    }
}

OEPresentationPresetController.defaultProps = {
    moduleId:               '',
    id:                     -1,
    titleId:                'pres_apply_presets',
    headerSeparator:        true,
    presetType:             OEPresetType.note,
    showTypeIconAllways:    true
};

OEPresentationPresetController.propTypes = {
    moduleId:               PropTypes.string,
    className:              PropTypes.string,
    icon:                   PropTypes.string,
    title:                  PropTypes.string,
    titleId:                PropTypes.string,
    headerSeparator:        PropTypes.bool,
    id:                     PropTypes.number,
    presetType:             PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
    showTypeIconAllways:    PropTypes.bool,
    onToggle:               PropTypes.func
};

//
export const OEPresentationPresetPopover = OEPopover.coat(OEPresentationPresetController, {
    noHeader:               true,
}, {
    placement:              'right-start',
    buttonClassName:        'transparent-btn',
    controllerClassName:    ''
}, {
    controllerClassName:    PropTypes.string
});

export default withIsOpenState(OEPresentationPresetPopover);